import { RectNode, RectNodeModel, h } from '@logicflow/core';
import { drawLabel } from './textUtils';
import { getThemeStyle } from '../theme';

class TextAnnotationView extends RectNode {
  getShape() {
    const { model } = this.props;
    const { x, y, width, height } = model;
    const style = model.getNodeStyle();
    const label = model.properties?.text || model.text?.value || '';
    const textFill = (model.graphModel?.__epxDmnTheme?.text?.fill) || '#212121';

    const l = x - width / 2;
    const r = x + width / 2;
    const t = y - height / 2;
    const b = y + height / 2;
    const bracket = 10;

    return h('g', {}, [
      // Rect (invisible body for anchor / hit testing)
      h('rect', {
        x: l, y: t, width, height,
        fill: 'transparent',
        stroke: 'transparent',
      }),
      // Left bracket only: ⎡ ... ⎣
      h('path', {
        d: `M ${l + bracket} ${t} L ${l} ${t} L ${l} ${b} L ${l + bracket} ${b}`,
        fill: 'none',
        stroke: style.stroke,
        strokeWidth: 1,
      }),
      drawLabel(h, label, x + bracket / 2, y, width - bracket * 2, { anchor: 'start', xOverride: l + bracket + 4, fill: textFill }),
    ]);
  }

  getText() { return ''; }
}

class TextAnnotationModel extends RectNodeModel {
  initNodeData(data) {
    super.initNodeData(data);
    this.width = 160;
    this.height = 40;
    this.text = { ...this.text, editable: false, draggable: false, value: '' };
  }

  getNodeStyle() {
    const style = super.getNodeStyle();
    const t = getThemeStyle(this.graphModel, 'textAnnotation');
    style.stroke = t.stroke || '#8c8c8c';
    style.strokeWidth = t.strokeWidth || 1;
    style.fill = 'transparent';
    return style;
  }
}

export const TextAnnotation = {
  type: 'dmn:TextAnnotation',
  view: TextAnnotationView,
  model: TextAnnotationModel,
};
